/**
 * Created by zzy on 2019/8/5.
 */
import OperationLogs from './OperationLogs.vue'
export default OperationLogs



// WEBPACK FOOTER //
// ./src/views/events/OperationLogs/index.js